// import styles
import "./Create.css";

// import pacchetti
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { timestamp } from "../../firebase/config";
import Select from "react-select";

// import hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";

const settori = [
  { value: "Edile", label: "Settore Edile" },
  { value: "Cucine", label: "Settore Equipment Cucine" },
  { value: "Intesa", label: "Settore Banca Intesa" },
  { value: "Elettrico", label: "Settore Elettrico" },
  { value: "FTV", label: "Settore Fotovoltaico" },
  { value: "ROBY", label: "Personale Roby" },
  { value: "Amministrazione", label: "Spese Amministrative" },
  { value: "Verona", label: "Cucine Verona" },
];

const tipiProject = [
  { value: "cantiere", label: "Cantiere" },
  { value: "commessa", label: "Commessa" },
  { value: "centro-di-costo", label: "Centro di Costo" },
];

export default function Create() {
  const navigazione = useNavigate();
  const { user } = useAuthContext();
  const { addDocument, response } = useFirestore("projects");
  // useCollection per recuperare i dati degli utenti dal database - rimosso
  // const { documents } = useCollection("users");
  // creiamo un nuovo state per gestire la modifica all'oggetto documents - rimosso
  // const [utenti, setUtenti] = useState([]);

  // state per gestire i valori degli input
  const [tipoProject, setTipoProject] = useState(tipiProject[0]);
  const [nome, setNome] = useState("");
  const [dettagli, setDettagli] = useState("");
  const [scadenza, setScadenza] = useState("");
  const [categoria, setCategoria] = useState("");
  const [preventivo, setPreventivo] = useState("");
  const [cliente, setCliente] = useState("");
  const [localizzazione, setLocalizzazione] = useState("");
  const [codice, setCodice] = useState("");
  const [formError, setFormError] = useState(null);

  // map sull'oggetto documents per creare un oggetto che abbia un value e un label per il componente select - rimosso
  // useEffect inserendo come dipendenza documents in modo che ogni volta che documents cambia la funzione viene eseguita - rimosso
  // useEffect(() => {
  //   if (documents) {
  //     const options = documents.map((utente) => {
  //       let label = utente.displayName;
  //       if (utente.anagrafica) {
  //         label = `${utente.anagrafica.nome} ${utente.anagrafica.cognome}`;
  //       }
  //       return {
  //         value: utente,
  //         label: label,
  //       };
  //     });
  //     setUtenti(options);
  //   }
  // }, [documents]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(null);
    if (!tipoProject) {
      setFormError("Seleziona un tipo di project");
      return;
    }
    if (!categoria) {
      setFormError("Seleziona un settore");
      return;
    }
    if (tipoProject.value === "cantiere") {
      if (!scadenza) {
        setFormError("Imposta una data di scadenza");
        return;
      }
      // Preventivo è ora opzionale, non è più richiesta validazione
    }
    if (tipoProject.value !== "centro-di-costo") {
      if (!cliente) {
        setFormError("Inserisci un cliente/committente");
        return;
      }
      if (!localizzazione) {
        setFormError("Inserisci una localizzazione");
        return;
      }
    }

    const autore = {
      displayName: user.displayName,
      photoURL: user.photoURL,
      id: user.uid,
    };

    // creiamo un array di utenti nel formato richiesto - rimosso
    // const listaUtentiCoinvolti = utentiCoinvolti.map((utente) => {
    //   return {
    //     displayName: utente.value.displayName,
    //     photoURL: utente.value.photoURL,
    //     id: utente.value.id,
    //   };
    // });

    const projectObj = {
      nome,
      dettagli,
      tipoProject: tipoProject.value,
      categoria: categoria.value,
      scadenza:
        tipoProject.value === "cantiere"
          ? timestamp.fromDate(new Date(scadenza))
          : null,
      comments: [],
      autore,
      completato: false,
      preventivo:
        tipoProject.value === "cantiere" ? parseFloat(preventivo) || 0 : 0,
      cliente: tipoProject.value === "centro-di-costo" ? "" : cliente,
      localizzazione:
        tipoProject.value === "centro-di-costo" ? "" : localizzazione,
      codice,
      costiSostenuti: 0,
      avanzamento: 0,
      createdAt: timestamp.fromDate(new Date()),
    };

    addDocument(projectObj);
  };

  useEffect(() => {
    console.log("Response state:", response);
    if (response.success) {
      console.log("Reindirizzamento in corso, document:", response.document);
      // Reindirizza al project appena creato invece che alla lista generale
      // Passa anche lo stato isNewlyCreated per indicare che il project è stato appena creato
      try {
        // Corretto il percorso da /projects/ a /project/ per corrispondere alla route definita in App.js
        console.log(
          "URL di reindirizzamento corretto:",
          `/project/${response.document.id}`,
        );
        navigazione(`/project/${response.document.id}`, {
          state: { isNewlyCreated: true },
        });
      } catch (error) {
        console.error("Errore durante il reindirizzamento:", error);
      }
    }
  }, [response.success, response.document, navigazione, response]);

  return (
    <div className="create-form">
      <h2 className="page-title">Nuovo Project</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Tipo di Project:</span>
          <Select
            onChange={(option) => setTipoProject(option)}
            options={tipiProject}
            value={tipoProject}
            isSearchable={true}
          />
        </label>
        <label>
          <span>Titolo:</span>
          <input
            required
            type="text"
            onChange={(e) => setNome(e.target.value)}
            value={nome}
          />
        </label>
        <label>
          <span>Codice Project:</span>
          <input
            required
            type="text"
            onChange={(e) => setCodice(e.target.value)}
            value={codice}
          />
        </label>
        <label>
          <span>Dettagli:</span>
          <textarea
            required
            type="text"
            onChange={(e) => setDettagli(e.target.value)}
            value={dettagli}
          ></textarea>
        </label>
        {tipoProject.value === "cantiere" && (
          <label>
            <span>Imposta scadenza:</span>
            <input
              required
              type="date"
              onChange={(e) => setScadenza(e.target.value)}
              value={scadenza}
            />
          </label>
        )}
        <label>
          <span>Settore:</span>
          <Select
            onChange={(option) => setCategoria(option)}
            options={settori}
            isSearchable={true}
          />
        </label>
        {/* Componente per l'assegnazione degli utenti rimosso */}
        {tipoProject.value === "cantiere" && (
          <label>
            <span>Preventivo (€):</span>
            <input
              type="number"
              step="0.01"
              min="0"
              onChange={(e) => setPreventivo(e.target.value)}
              value={preventivo}
            />
          </label>
        )}
        {tipoProject.value !== "centro-di-costo" && (
          <>
            <label>
              <span>Cliente/Committente:</span>
              <input
                required
                type="text"
                onChange={(e) => setCliente(e.target.value)}
                value={cliente}
              />
            </label>

            <label>
              <span>Localizzazione:</span>
              <input
                required
                type="text"
                onChange={(e) => setLocalizzazione(e.target.value)}
                value={localizzazione}
              />
            </label>
          </>
        )}
        <button className="btn">Crea project</button>
        {formError && <p className="error">{formError}</p>}
      </form>
      <br />
    </div>
  );
}
